import { Props } from "."

export const mockProps: Props = {
  onClick: () => {},
  label: "Show password",
  icon: "visibilitySm",
}
